import { SvgIcon, SxProps } from "@mui/material";
import SvgThumbUpIcon from "jsx:../../../Images/Icons/FontAwesome/light/thumbs-up.svg";

export function ThumbsUpLightIcon(props: SxProps) {
    return <SvgIcon component={SvgThumbUpIcon} inheritViewBox sx={props} />;
}
